var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"esp"},[_c('mdb-badge',{attrs:{"pill":"","color":_vm.item.color}},[_vm._v(_vm._s(_vm.item.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }